export function getProcessDefinitionKeyFromId(processDefinitionId?: string | null): string | null {
  const trimmed = processDefinitionId?.trim();
  if (!trimmed) {
    return null;
  }

  const [key] = trimmed.split(":");
  return key || null;
}

export function resolveProcessDefinitionResourceId(
  processDefinitionIdOrKey?: string,
  explicitProcessDefinitionKey?: string,
): string | undefined {
  const explicitKey = explicitProcessDefinitionKey?.trim();
  if (explicitKey) {
    return explicitKey;
  }

  return getProcessDefinitionKeyFromId(processDefinitionIdOrKey) ?? undefined;
}

export function encodeCamundaPathSegment(value: string): string {
  return encodeURIComponent(value);
}
